// Solo dashboard stats (§5.2). Leads with the taste signature (who you are as a
// viewer), then the rating personality and era/logging charts.
//
// NOTE: the enriched "Deep focus" tier (genres, directors, hot takes) is HIDDEN
// for now. Client-side TMDB enrichment doesn't scale to large libraries (a 1k+
// film sweep is thousands of requests). It'll return backed by a Supabase
// function that enriches + caches metadata server-side (shared across users).
// Until then we render only the instant tier and skip the TMDB sweep entirely.

import type { DistilledProfile } from "../lib/types.ts";
import { RatingHistogram, DecadeBars, HeatStrip } from "./Charts.tsx";
import { TasteSignature } from "./TasteSignature.tsx";

export function SoloStats({ profile }: { profile: DistilledProfile }) {
  return (
    <div data-testid="section-solo-stats" className="space-y-6">
      {/* Instant-only signals — no enrichment sweep. */}
      <TasteSignature profile={profile} />

      <div className="card">
        <h3 className="section-title mb-3">Rating personality</h3>
        <RatingHistogram hist={profile.aggregates.ratingHist} />
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card">
          <h3 className="section-title mb-3">By decade</h3>
          <DecadeBars byDecade={profile.aggregates.byDecade} />
        </div>
        <div className="card">
          <h3 className="section-title mb-3">Logged per month</h3>
          <HeatStrip loggedByMonth={profile.aggregates.loggedByMonth} />
        </div>
      </div>
    </div>
  );
}
